export interface PieChartData {
  title: string;
  labels: string[];
  data: number[];
}

export const PIE_DEFAULT_COLORS = [
  "#f59e0b",
  "#ef4444",
  "#3b82f6",
  "#10b981",
  "#f97316",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
];

export function parsePieChartBlock(jsonStr: string): PieChartData | null {
  try {
    const raw = JSON.parse(jsonStr);

    if (
      typeof raw.title !== "string" ||
      !Array.isArray(raw.labels) ||
      raw.labels.length === 0 ||
      !Array.isArray(raw.data) ||
      raw.data.length === 0 ||
      raw.labels.length !== raw.data.length
    )
      return null;

    for (const label of raw.labels) {
      if (typeof label !== "string") return null;
    }

    for (const val of raw.data) {
      if (typeof val !== "number") return null;
    }

    return {
      title: raw.title,
      labels: raw.labels,
      data: raw.data,
    };
  } catch {
    return null;
  }
}
